export default class Actionable {
  static selector = ".actionable";

  constructor(block) {
    this.block = block;

    const dataAction = this.block.dataset.action;

    if (dataAction) {
      // parse this shape 'modal.SignupModal:open' and get 'modal', 'SignupModal'
      // and 'open'
      const [typeName, method] = dataAction.split(":");
      const [type, name] = typeName.split(".");

      this.type = type;
      this.name = name;
      this.method = method;
    }

    this.block.addEventListener("click", this.handleClick);
  }

  handleClick = e => {
    let subject = false;

    if (this.type && this.name) {
      subject = window.App[this.type][this.name];
    } else if (this.type) {
      subject = window.App[this.type];
    }

    subject?.[this.method]?.();
  };
}
